'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuButton = require('@viskan/deku-button');

var _dekuButton2 = _interopRequireDefault(_dekuButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = function initialState() {
	return {};
};

var processList = function processList(list, index, setState, props) {
	var curr = list[index];

	props.shopcartAdd(curr.buyObj).then(function () {
		return !setState(_defineProperty({}, curr.key, _extends({}, curr.item, { success: true }))) && list[index + 1] && processList(list, index + 1, setState, props);
	}).catch(function () {
		return !setState(_defineProperty({}, curr.key, _extends({}, curr.item, { success: false }))) && list[index + 1] && processList(list, index + 1, setState, props);
	});
};

var addToCart = function addToCart(props, setState) {
	return function () {
		setState(initialState());

		var list = Object.entries(props.buylist).filter(function (_ref) {
			var _ref2 = _slicedToArray(_ref, 2),
			    item = _ref2[1];

			return item.qty > 0;
		}).map(function (_ref3) {
			var _ref4 = _slicedToArray(_ref3, 2),
			    key = _ref4[0],
			    item = _ref4[1];

			return {
				key: key,
				item: item,
				buyObj: {
					art_id: props.article.art_id,
					attr1_id: item.attr1_id,
					attr2_id: item.attr2_id,
					attr3_id: item.attr3_id,
					qty: item.qty
				}
			};
		});

		if (list.length !== 0) {
			processList(list, 0, setState, props);
		}
	};
};

var getFeedbackDisplayType = function getFeedbackDisplayType(item, props) {
	switch (props.feedbackDisplayType) {
		case 'attributes':
			{
				return ((item.attr1_id ? item.attribute1.attr1_code : '') + ' ' + (item.attr2_id ? item.attribute2.attr2_code : '') + ' ' + (item.attr3_id ? item.attribute3.attr3_code : '')).trim();
			}
		case 'pluno':
			{
				return item.pluno;
			}
		case 'ean13':
			{
				return item.ean13;
			}
		default:
			{
				return '';
			}
	}
};

var getSuccessMsg = function getSuccessMsg(item, props) {
	return 'Added ' + item.qty + ' of ' + getFeedbackDisplayType(item, props) + ' to the shopcart';
};
var getFailureMsg = function getFailureMsg(item, props) {
	return 'Failed to add ' + item.qty + ' of ' + getFeedbackDisplayType(item, props) + ' to the shopcart';
};

var renderStatus = function renderStatus(props, state) {
	return (0, _magicVirtualElement2.default)(
		'div',
		null,
		(0, _magicVirtualElement2.default)(
			'div',
			null,
			Object.entries(state).filter(function (_ref5) {
				var _ref6 = _slicedToArray(_ref5, 2),
				    item = _ref6[1];

				return item.success;
			}).map(function (_ref7) {
				var _ref8 = _slicedToArray(_ref7, 2),
				    key = _ref8[0],
				    item = _ref8[1];

				return (0, _magicVirtualElement2.default)(
					'div',
					{ key: key, 'class': props.styleClasses.Success_Message },
					getSuccessMsg(item, props)
				);
			})
		),
		(0, _magicVirtualElement2.default)(
			'div',
			null,
			Object.entries(state).filter(function (_ref9) {
				var _ref10 = _slicedToArray(_ref9, 2),
				    item = _ref10[1];

				return !item.success;
			}).map(function (_ref11) {
				var _ref12 = _slicedToArray(_ref11, 2),
				    key = _ref12[0],
				    item = _ref12[1];

				return (0, _magicVirtualElement2.default)(
					'div',
					{ key: key, 'class': props.styleClasses.Failure_Message },
					getFailureMsg(item, props)
				);
			})
		)
	);
};

var render = function render(_ref13, setState) {
	var props = _ref13.props,
	    state = _ref13.state;

	if (!props.isBuyable) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': 'CMS-Component-SKU-Table-AddToCart' },
		(0, _magicVirtualElement2.default)(
			_dekuButton2.default,
			{ styleClasses: props.styleClasses, name: 'Buy_Button', onClick: addToCart(props, setState) },
			props.buyButtonText
		),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': props.styleClasses.Feedback_Wrapper, 'data-style-attr': 'Feedback_Wrapper' },
			renderStatus(props, state)
		),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Success_Message' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Failure_Message' })
	);
};

exports.default = { render: render, initialState: initialState, name: 'CMS-Component-SKU-Table-AddToCart' };